var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcludeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.7511 16.8584C14.7511 18.7234 13.9398 20.4092 12.6438 21.5577C11.5269 22.5692 10.0518 23.1803 8.42919 23.1803C4.94161 23.1803 2.1073 20.346 2.1073 16.8584C2.1073 13.9504 4.08816 11.4848 6.76442 10.7578C7.49144 12.5912 9.05084 14.003 10.979 14.5299C11.5058 14.6774 12.0643 14.7511 12.6438 14.7511C13.2233 14.7511 13.7817 14.6774 14.3085 14.5299C14.593 15.2464 14.7511 16.0366 14.7511 16.8584Z",
    fill: "#5030E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9657 8.42931C18.9657 9.25116 18.8076 10.0414 18.5231 10.7579C17.7961 12.5912 16.2367 14.0031 14.3086 14.5299C13.7817 14.6774 13.2233 14.7512 12.6438 14.7512C12.0643 14.7512 11.5058 14.6774 10.979 14.5299C9.05085 14.0031 7.49145 12.5912 6.76443 10.7579C6.47995 10.0414 6.3219 9.25116 6.3219 8.42931C6.3219 4.94174 9.15621 2.10742 12.6438 2.10742C16.1314 2.10742 18.9657 4.94174 18.9657 8.42931Z",
    fill: "#5030E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.1803 16.8584C23.1803 20.346 20.346 23.1803 16.8584 23.1803C15.2358 23.1803 13.7607 22.5692 12.6438 21.5577C13.9398 20.4092 14.7511 18.7234 14.7511 16.8584C14.7511 16.0366 14.593 15.2464 14.3086 14.5299C16.2367 14.003 17.7961 12.5912 18.5232 10.7578C21.1994 11.4848 23.1803 13.9504 23.1803 16.8584Z",
    fill: "#5030E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcludeLogo);
export default __webpack_public_path__ + "static/media/nclude-logo.f3d657a36de96567d921a1134f8a3d0b.svg";
export { ForwardRef as ReactComponent };